import { render, staticRenderFns } from "./BaseColumn.vue?vue&type=template&id=69e48688&scoped=true&"
import script from "./BaseColumn.vue?vue&type=script&lang=js&"
export * from "./BaseColumn.vue?vue&type=script&lang=js&"
import style0 from "./BaseColumn.vue?vue&type=style&index=0&id=69e48688&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e48688",
  null
  
)

export default component.exports